import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { queryClient } from "../lib/queryClient";
import { meQuery, type Me } from "../hooks/useAuth";
import { hasPermission } from "../hooks/useCan";
import { SalesPlanScreen } from "../components/sales-plan/SalesPlanScreen";

const searchSchema = z.object({
  tab: z.enum(["overview", "daily", "variance", "mix", "pnl", "plan"]).default("overview"),
  plan: z.string().optional(),
  // First day of a plan month (YYYY-MM-01), for the daily and variance views.
  month: z.string().optional(),
});

export type SalesPlanSearch = z.infer<typeof searchSchema>;
export type SalesPlanTab = SalesPlanSearch["tab"];

export const Route = createFileRoute("/_auth/sales-plan")({
  staticData: {
    titleKey: "salesPlan.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 12,
  },
  validateSearch: searchSchema,
  beforeLoad: () => {
    const me = queryClient.getQueryData<Me>(meQuery.queryKey);
    if (!me) return;
    if (!hasPermission(me, "view_sales_plan")) {
      throw redirect({ to: "/clients" });
    }
  },
  component: SalesPlanScreen,
});
